 var numberWithCommas = function numberWithComas(x){
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatNumber(num) {
  if (num === null || num === undefined) return '';
  if (num < 1000) return num.toString();

  const units = ["", "K", "M", "B", "T"];
  const order = Math.floor(Math.log10(num) / 3);
  const unit = units[order] || "";
  const scaled = num / Math.pow(10, order * 3);

  // Show up to 1 decimal, but remove trailing .0
  return `${parseFloat(scaled.toFixed(2))}${unit}`;
}

export {numberWithCommas, formatNumber}
